import { DataReceiptForm, ReceiptShippingInfoWrapper } from "../../models/DataReceipt"
import { ValidatorModel } from "../../validation"

interface ValidateDataReceipt extends DataReceiptForm {
    detail_wrappers: ReceiptShippingInfoWrapper[]
}

type keyofDataReceipt = keyof ValidateDataReceipt

const dataReceiptDisplayNames: { [key in keyofDataReceipt]?: string } = {
    date_received: "Date Received",
    office: "Office",
    detail_wrappers: "Selected Missions",
    received_by: "Received By",
}

export const getCreateDataReceiptModel = (
    dataReceipt: DataReceiptForm,
    detailWrappers: ReceiptShippingInfoWrapper[],
): ValidatorModel => {
    const model: ValidateDataReceipt = { ...dataReceipt, detail_wrappers: detailWrappers }

    const selectMissionsRequiredFields: keyofDataReceipt[] = ["detail_wrappers"]
    const receiptDetailsRequiredFields: keyofDataReceipt[] = ["date_received", "office", "received_by"]
    const requiredFields: keyofDataReceipt[] = [...selectMissionsRequiredFields, ...receiptDetailsRequiredFields]

    const validateDetailsHaveSizeInGB = () => {
        return !!model.detail_wrappers.find((detail) => detail.detail.size_in_gb == null)
    }

    return {
        model: model,
        display_names: dataReceiptDisplayNames,
        required_fields: requiredFields,
        custom_validation_fields: [],
        unique_fields: [
            {
                name: "detail_wrappers",
                text: "Must select a mission for data receipt",
                isError: model.detail_wrappers.length < 1,
            },
            {
                name: "detail_wrappers",
                text: "Must specify size (GB)",
                isError: validateDetailsHaveSizeInGB(),
            },
        ],
        groups: {},
    }
}
